module.exports = __webpack_public_path__ + "img/yinyanghuoke-zhuchezheng.67888230.jpg";